import * as SubscriptionStatusTypes from '../constants/SubscriptionStatusTypes';
export default (type => !type || type === SubscriptionStatusTypes.OK || type === SubscriptionStatusTypes.OTHER_SUBSCRIPTION_REJECTED);